module.exports = __webpack_public_path__ + "media/media/cases/rosneft/rosneft1-19ba61355add70eac3b926932eab8417.jpg";